import React, { useState } from "react";
import { FormFieldSet } from "../../../../../components";
import { MONTHPICKER_PROPS, PropsTable } from "./Props/Props";

const CATEGORIES = {
  core: { label: "Core", color: "#EFF6FF", textColor: "#1D4ED8" },
  display: { label: "Display", color: "#F0FDF4", textColor: "#15803D" },
  behavior: { label: "Behavior", color: "#FFFBEB", textColor: "#B45309" },
  limit: { label: "Limit", color: "#FFF7ED", textColor: "#C2410C" },
};

const MonthPickerList = () => {
  const handleDateRangeChange = (value) => {
    console.log(value);
  };

  // Create this utility at the top of your component or in a separate file
  const DateHelper = {
    // Get today's date without time
    today: () => {
      const now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), now.getDate());
    },

    // Get tomorrow's date
    tomorrow: () => {
      const now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    },

    // Add days to current date
    addDays: (days) => {
      const now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), now.getDate() + days);
    },

    // Strip time from any date
    dateOnly: (date) => {
      if (!date) return null;
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    },

    // Add months to current date
    addMonths: (months) => {
      const now = new Date();
      return new Date(
        now.getFullYear(),
        now.getMonth() + months,
        now.getDate(),
      );
    },
  };

  return (
    <div>
      <div className="flex flex-col my-5 mb-30">
        <h4>Month Picker</h4>
        <div className="grid grid-cols-4 gap-5 my-5">
          <div>
            <FormFieldSet
              title="Select Month"
              placeholder="Select month"
              type="monthpicker"
            />
          </div>
          <div>
            <FormFieldSet
              title="Month Selected"
              placeholder="Select month"
              type="monthpicker"
              value={new Date(2025, 1, 1)}
              shadow={true}
            />
          </div>
          <div>
            <FormFieldSet
              title="Select Month"
              placeholder="Select month"
              type="monthpicker"
              disabled
              shadow={true}
            />
          </div>
          <div>
            <FormFieldSet
              title="Month Selected"
              placeholder="Select month"
              type="monthpicker"
              value={new Date(2025, 1, 1)}
              disabled
            />
          </div>
        </div>

        <div className="grid grid-cols-4 gap-5 my-5">
          <div>
            <FormFieldSet
              title="Min Month"
              placeholder="Select month"
              type="monthpicker"
              minDate={DateHelper.today()}
            />
          </div>
          <div>
            <FormFieldSet
              title="Max Month"
              placeholder="Select month"
              type="monthpicker"
              maxDate={DateHelper.addMonths(1)}
              shadow={true}
            />
          </div>
        </div>

        <div className="grid grid-cols-4 gap-5 my-5">
          <div>
            <FormFieldSet
              title="Month Range"
              placeholder="Select month"
              type="monthpickerRange"
              minDate={DateHelper.today()}
              maxDate={DateHelper.addMonths(3)}
            />
          </div>
          <div>
            <FormFieldSet
              title="Month Range"
              placeholder="Select month"
              type="monthpickerRange"
              value={{
                from: new Date(2025, 4, 1),
                to: new Date(2025, 7, 1),
              }}
              shadow={true}
            />
          </div>
          <div>
            <FormFieldSet
              title="Month Range"
              placeholder="Select month"
              type="monthpickerRange"
              minDate={DateHelper.today()}
              maxDate={DateHelper.addMonths(3)}
              disabled
            />
          </div>
          <div>
            <FormFieldSet
              title="Month Range"
              placeholder="Select month"
              type="monthpickerRange"
              value={{
                from: new Date(2025, 4, 1),
                to: new Date(2025, 7, 1),
              }}
              disabled
              shadow={true}
            />
          </div>
        </div>
      </div>
      <PropsTable
        data={MONTHPICKER_PROPS}
        title="monthpicker || monthpickerRange — Props Reference"
        typeLabel='type="monthpicker || monthpickerRange"'
        categories={CATEGORIES}
      />
    </div>
  );
};

export default MonthPickerList;
